import { processSilentRenew } from "redux-oidc";

const SilentCallback = () => {
  processSilentRenew();
  return null;
};

export default SilentCallback;
